(function () {
    'use strict';

    angular
        .module('surveyCampaignsModule')
        .controller('SurveyCampaignSectionListEditController', Controller);

    Controller.$inject = ['$scope', '$state', 'topBarService', 'businessUnit', 'campaign', 'questionnaireTemplate'];

    function Controller($scope, $state, topBarService , businessUnit,campaign, questionnaireTemplate) {

        topBarService.setTitleAndIcon('Survey | ' + businessUnit.TitleEN, 'icon icon-clipboard');
        $scope.questionnaireTemplate = questionnaireTemplate;
        $scope.campaign = campaign;
        $scope.goToSurveyCampaign = function () {
            $state.go('odd.surveyCampaignEdit', { ODDCampaignID: campaign.ODDCampaignID }, { reload: true });
        };

        $scope.goToCampaigns = function () {
            $state.go('odd.surveyCampaigns', { ODDBusinessUnitID: $scope.campaign.ODDBusinessUnitID }, { reload: true });
        };

    }
})();